function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { sendAnalytics } from '@audio-network/analytics';
import * as Styled from './Waveform.styles';
import { fetchWaveformData, getWaveform } from '../../../services/waveformService';
import { usePlayer, usePlayerAudio } from '../../../hooks';
import WaveformCanvas from './WaveformCanvas/WaveformCanvas';
import WaveformImage from './WaveformImage/WaveformImage';
var Waveform = function Waveform(_ref) {
  var track = _ref.track;
  var _usePlayerAudio = usePlayerAudio(),
    audioElement = _usePlayerAudio.audioElement,
    setCurrentTime = _usePlayerAudio.setCurrentTime;
  var _usePlayer = usePlayer(),
    currentTrack = _usePlayer.currentTrack,
    togglePlay = _usePlayer.togglePlay;
  var sliderRef = useRef(null);
  var clipPathRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    waveformData = _useState2[0],
    setWaveformData = _useState2[1];
  var isCurrentTrack = (currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.id) === (track === null || track === void 0 ? void 0 : track.id);
  useEffect(function () {
    setWaveformData(null);
    if (!(track !== null && track !== void 0 && track.id) || !(track !== null && track !== void 0 && track.waveformDataUrl)) return;
    var storedWaveformData = getWaveform(track.id);
    if (storedWaveformData) {
      setWaveformData(storedWaveformData);
    } else {
      fetchWaveformData([track]).then(function () {
        var newWaveformData = getWaveform(track.id);
        if (newWaveformData) {
          setWaveformData(newWaveformData);
        }
      });
    }
  }, [track === null || track === void 0 ? void 0 : track.id]);
  useEffect(function () {
    var handleTimeUpdate = function handleTimeUpdate() {
      if (!(sliderRef !== null && sliderRef !== void 0 && sliderRef.current)) return;
      if (audioElement && isCurrentTrack) {
        var currentTime = audioElement.currentTime;
        sliderRef.current.value = currentTime !== null && currentTime !== void 0 ? currentTime : 0;
        var percent = 100 - currentTime / track.duration * 100;
        clipPathRef.current.style.clipPath = "inset(0 ".concat(percent, "% 0 0)");
      }
    };
    if (!isCurrentTrack) {
      sliderRef.current.value = 0;
      clipPathRef.current.style.clipPath = "inset(0 100% 0 0)";
    }
    if (audioElement && isCurrentTrack) {
      audioElement.addEventListener('timeupdate', handleTimeUpdate);
    } else {
      audioElement.removeEventListener('timeupdate', handleTimeUpdate);
    }
    return function () {
      audioElement.removeEventListener('timeupdate', handleTimeUpdate);
    };
  }, [audioElement, currentTrack]);

  // Move early returns after all hooks are called
  if (!track) {
    return null;
  }
  var handleChange = function handleChange(event) {
    if (!track) return;
    if (isCurrentTrack && audioElement) {
      var value = event.target.value;
      setCurrentTime(value);
    } else {
      togglePlay(track);
    }
  };
  var handleMouseUp = function handleMouseUp() {
    sliderRef.current.blur();
    sendAnalytics(null, 'Player Waveform', 'Clicked');
  };
  var renderWaveform = function renderWaveform(props) {
    var showWaveformCanvas = !!(track !== null && track !== void 0 && track.waveformDataUrl);
    if (showWaveformCanvas) {
      if (waveformData) {
        return /*#__PURE__*/React.createElement(WaveformCanvas, _extends({
          waveformData: waveformData
        }, props));
      }
      return null;
    }
    return /*#__PURE__*/React.createElement(WaveformImage, _extends({
      track: track
    }, props));
  };
  return /*#__PURE__*/React.createElement(Styled.WaveformContainer, null, /*#__PURE__*/React.createElement(Styled.Waveform, null, renderWaveform()), /*#__PURE__*/React.createElement(Styled.Waveform, {
    willClip: true,
    ref: clipPathRef
  }, renderWaveform({
    clipped: true
  })), /*#__PURE__*/React.createElement(Styled.Slider, {
    ref: sliderRef,
    onChange: handleChange,
    onMouseUp: handleMouseUp,
    type: "range",
    "aria-label": "Track playback position",
    min: 0,
    max: (track === null || track === void 0 ? void 0 : track.duration) || 1,
    step: 1,
    "data-waveform-slider": true,
    tabIndex: -1,
    autoComplete: "off"
  }));
};
Waveform.propTypes = {
  track: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    waveformDataUrl: PropTypes.string,
    waveformImageUrl: PropTypes.string,
    type: PropTypes.string,
    album: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      number: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    albumTrackNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    duration: PropTypes.number
  })
};
Waveform.defaultProps = {
  track: null
};

// Export the component directly
export default /*#__PURE__*/React.memo(Waveform, function (prevProps, nextProps) {
  // Only re-render if track id changes or if no track was provided
  if (!prevProps.track || !nextProps.track) {
    return prevProps.track === nextProps.track;
  }

  // Compare track ids - only re-render if the track id changes
  return prevProps.track.id === nextProps.track.id;
});